module.exports = __webpack_public_path__ + "static/media/redefining_tomorrow.14a68374.jpg";